// groups shipments that share the same displayed shipping method (name/
// translation key + carrier) into one entry with a count, so "DPD (5)" shows
// on a single line instead of repeating "DPD" once per shipment
export function groupShipmentsByMethod(shipments) {
    const groups = {};

    shipments.forEach(shipment => {
        const shippingMethod = shipment.shippingMethod;
        const key = `${shippingMethod?.discr}|${shippingMethod?.name ?? shippingMethod?.shippingMethodShopName}`;

        if (!groups[key]) {
            groups[key] = {shippingMethod, count: 0};
        }

        groups[key].count++;
    });

    return Object.values(groups);
}
